
export const getRandomInt = () : number => {
  const crypto : Crypto = window.crypto || (window as any)['msCrypto'];
  return crypto.getRandomValues(new Uint32Array(1))[0];
};